import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';

import { PanelBody, SelectControl } from "@wordpress/components";

import defaultColors from '../../assets/defaultColors';

import ColorControl from '../../components/color-control';

function CardEdit(props) {
  const [bgColor, setBgColor] = useState(props.value.card.backgroundColor);
  const [color, setColor] = useState(props.value.card.color);
  const [textSize, setTextSize] = useState(props.value.text.fontSize);
  const [anotherSize, setAnotherSize] = useState(props.value.another.fontSize);
  const [titleSize, setTitleSize] = useState(props.value.title.fontSize);

  const sizeForTitle = [
    {label: __('Extra-less'), value: '14px'},
    {label: __('Less'), value: '16px'},
    {label: __('Extra-small'), value: '18px'},
    {label: __('Small'), value: '20px'},
    {label: __('Normal'), value: '24px'},
    {label: __('Large'), value: '28px'},
    {label: __('Huge'), value: '32px'}
  ];
  const sizeForText = [
    {label: __('Small'), value: '18px'},
    {label: __('Normal'), value: '20px'},
    {label: __('Large'), value: '22px'},
    {label: __('Huge'), value: '24px'}
  ];
  const sizeForAnother = [
    {label: __('Small'), value: '14px'},
    {label: __('Normal'), value: '16px'},
    {label: __('Large'), value: '18px'},
    {label: __('Huge'), value: '20px'}
  ];

  useEffect(() => {
    props.onChange({
      card: {
        backgroundColor: bgColor,
        color: color
      },
      title: {
        color: color,
        fontSize: titleSize
      },
      text: {
        color: color,
        fontSize: textSize
      },
      another: {
        color: color,
        fontSize: anotherSize
      }
    });
  }, [
    bgColor, 
    color, 
    anotherSize, 
    textSize, 
    titleSize
  ]);

  return (
    <PanelBody title={__('Card style setting')} initialOpen={false} >
      <ColorControl
        label={__('Background color')}
        value={bgColor}
        colors={defaultColors}
        onChange={setBgColor}
      />
      <ColorControl
        label={__('Text color')}
        value={color}
        colors={defaultColors}
        onChange={setColor}
      />
      <SelectControl 
        label={__('Title size')}
        options={sizeForTitle}
        value={titleSize}
        onChange={setTitleSize}
      />
      <SelectControl 
        label={__('Text size')}
        options={sizeForText}
        value={textSize}
        onChange={setTextSize}
      />
      <SelectControl 
        label={__('Another text size')}
        options={sizeForAnother}
        value={anotherSize}
        onChange={setAnotherSize}
      />
    </PanelBody>
  );
}

export default CardEdit;